import { FC, useState, useEffect } from 'react'
import clsx from 'clsx'

import A from 'utils/metrics/analytic'
import { A_SUMMARY_OPEN } from 'constants/analytic-data'
import { STATIC_URL } from 'constants/data'

import styles from './accordeon.module.scss'

const imgPath = {
  dropdown: `${STATIC_URL}/navbar/dropdown_blue.svg`,
}
interface IAccordeon {
  title: string
  text: any
  modificator?: string
  initState?: boolean
  isBlack?: boolean
  isWhite?: boolean
  isBlueWhenOpened?: boolean
}

const Accordeon: FC<IAccordeon> = ({
  title,
  text,
  modificator,
  initState,
  isBlack,
  isWhite,
  isBlueWhenOpened,
}: IAccordeon) => {
  const [isOpen, setOpen] = useState(false)

  const toggleAccordeon = () =>
    setOpen((prev) => {
      if (!prev && modificator === 'fullWidth') A.setEvent(A_SUMMARY_OPEN)
      return !prev
    })

  useEffect(() => {
    if (initState) setOpen(true)
  }, [initState])

  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.wrapperOpen]: isOpen,
        [styles.wrapperFullWidth]: modificator === 'fullWidth',
        [styles.wrapperWebinar]: modificator === 'webinar',
        [styles.wrapperAiMedicus]: modificator === 'aiMedicus',
      })}
    >
      <div
        className={clsx(styles.accordion, {
          [styles.accordionOpen]: isOpen,
          [styles.noBeforeElem]: modificator === 'arrow',
          [styles.fullWidth]: modificator === 'fullWidth',
          [styles.webinarAccordeon]: modificator === 'webinar',
          [styles.isWhite]: isWhite,
          [styles.isBlue]: isBlueWhenOpened && isOpen,
        })}
        onClick={toggleAccordeon}
      >
        <div
          className={clsx(styles.icon, {
            [styles.isBlack]: isBlack,
            [styles.isHidden]: modificator === 'arrow',
            [styles.webinarIcon]: modificator === 'webinar',
            [styles.iconAiMedicus]: modificator === 'aiMedicus',
          })}
        />

        <h2
          className={clsx(styles.title, {
            [styles.titleAiMedicus]: modificator === 'aiMedicus',
          })}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {modificator === 'arrow' && (
          <img
            src={imgPath.dropdown}
            alt="Посмотреть подробности"
            className={clsx(styles.dropdown, { [styles.dropdownRotated]: isOpen })}
          />
        )}
      </div>
      <div
        className={clsx(styles.panel, {
          [styles.panelOpen]: isOpen,
          [styles.panelOpenFullWidth]: isOpen && modificator === 'fullWidth',
          [styles.panelOpenWebinar]: isOpen && modificator === 'webinar',
        })}
      >
        {modificator !== 'webinar' && <p className={styles.emptySpaceFiller}></p>}
        <div
          className={clsx(styles.paragraph, {
            [styles.smallerPadding]: modificator === 'arrow',
            [styles.transparent]: !isOpen,
          })}
        >
          {text}
        </div>
      </div>
    </div>
  )
}

export default Accordeon
